<template>
  <v-breadcrumbs class="pa-0 text-body-2 app-breadcrumbs flex-wrap">
    <template
      v-for="(item, idx) in items"
      :key="item.title + 'item'"
    >
      <v-breadcrumbs-item
        v-bind="item"
        :class="item.disabled ? 'text-ui-kit-text-secondary' : 'text-primary'"
        @click="onItemClick(item)"
      >
        {{ item.title }}
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider
        v-if="idx !== items.length - 1"
        divider="/"
        class="text-ui-kit-text-secondary"
      />
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { IBreadcrumb } from '~/types'
import { AWARD_ROUTE_NAMES, GRAND_PRIX_ROUTE_NAMES } from '~/features/Home/constants'

const props = defineProps({
  breadcrumbs: { type: Array as PropType<IBreadcrumb[]>, default: () => [] },
})

const $route = useRoute()
const mainStore = useMainStore()

const year = computed(() => $route.params.year as string)

const typeBreadcrumb = computed<IBreadcrumb>(() => {
  const isAwards = /awards/.test(String($route.fullPath))
  const title = isAwards ? 'Результаты премии' : 'Результаты Гран-при'
  const toName = isAwards ? AWARD_ROUTE_NAMES.main : GRAND_PRIX_ROUTE_NAMES.doctor
  const year = isAwards ? mainStore.awardYears[0] : mainStore.grandPrixYears[0]

  return {
    title,
    to: { name: toName, params: { year } },
  }
})

const defaultBreadcrumbs = computed<IBreadcrumb[]>(() => [
  {
    title: 'Главная',
    disabled: false,
    to: { name: 'index' },
  },
  typeBreadcrumb.value,
  {
    disabled: false,
    title: year.value,
    to: { ...typeBreadcrumb.value.to, params: { year: year.value } },
  },
])

const items = computed(() => {
  const breadcrumbs = [
    ...defaultBreadcrumbs.value,
    ...props.breadcrumbs,
  ]

  breadcrumbs[breadcrumbs.length - 1].disabled = true

  return breadcrumbs
})

function onItemClick(item: IBreadcrumb) {
  setTimeout(() => {
    const isSameName = $route.name === item?.to?.name
    const isSameYear = $route.params.year === item?.to?.params?.year

    if (isSameName && isSameYear) {
      location.reload()
    }
  })
}
</script>

<style lang="scss">
.app-breadcrumbs {
  a {
    text-decoration: none !important;
  }
}
</style>
